import React, { useEffect, useState } from 'react'
import Api from '../../../../../services/Api'
import { INFTCardFormatted } from '../../../components/NFTCard/INFTCard'
import BaseCard from '../../Base/Card/BaseCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'
import { getTokenUri } from '../../../../../services/NFTMarketPlace/Graphquery'
import { IGeneralCard } from '../../Generals/Card/IGeneralCard'
import { RarityClass } from '../../../data/NFTCollections/AvaPepesData'

export default function AvaPepeCard(props: INFTCardFormatted) {
  const { tokenId, collection } = props
  const [tokenUri, setTokenUri] = useState('')
  const [tokenItem, setTokenItem] = useState<IGeneralCard | null>(null)

  const tokenName = tokenItem ? tokenItem.name : collection.name
  let foundedRarityClass: { bgColor: string; percent: string } | undefined = undefined

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => setTokenUri(res))
    }
    if (tokenUri) {
      Api.get(tokenUri).then((tokenResult: any) => setTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  if (tokenItem && tokenItem.attributes) {
    const foundClass = tokenItem.attributes.find(item => item.trait_type === 'Class')
    if (foundClass) {
      foundedRarityClass = RarityClass[foundClass.value]
    }
  }

  function getImage() {
    return (
      <div className="default-image">
        {tokenItem ? (
          <img src={tokenItem.image.replace('gateway.pinata.cloud', 'ipfs.io')} alt={tokenItem.name} />
        ) : (
          <NFTImageSkeleton />
        )}
      </div>
    )
  }

  return (
    <BaseCard
      tokenName={tokenName}
      customStyleCardImage={foundedRarityClass ? { backgroundImage: foundedRarityClass.bgColor } : undefined}
      {...props}
    >
      {getImage()}
    </BaseCard>
  )
}
